"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterLinkColumnToJSON = exports.FooterLinkColumnFromJSONTyped = exports.FooterLinkColumnFromJSON = exports.instanceOfFooterLinkColumn = void 0;
var runtime_1 = require("../runtime");
var FooterLinkItem_1 = require("./FooterLinkItem");
/**
 * Check if a given object implements the FooterLinkColumn interface.
 */
function instanceOfFooterLinkColumn(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFooterLinkColumn = instanceOfFooterLinkColumn;
function FooterLinkColumnFromJSON(json) {
    return FooterLinkColumnFromJSONTyped(json, false);
}
exports.FooterLinkColumnFromJSON = FooterLinkColumnFromJSON;
function FooterLinkColumnFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'heading': !(0, runtime_1.exists)(json, 'heading') ? undefined : json['heading'],
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(FooterLinkItem_1.FooterLinkItemFromJSON)),
    };
}
exports.FooterLinkColumnFromJSONTyped = FooterLinkColumnFromJSONTyped;
function FooterLinkColumnToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'heading': value.heading,
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(FooterLinkItem_1.FooterLinkItemToJSON)),
    };
}
exports.FooterLinkColumnToJSON = FooterLinkColumnToJSON;
